import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Card, CardContent, CardHeader, Chip, CircularProgress, Dialog, DialogActions, DialogContent, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';
import 'moment/locale/es-mx';

import { DownloadFile } from '../../helpers/DownloadFile';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';

import { RootState } from '../../store';

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';

import { Layout } from '../../components/Layout';

import { DialogExpediente } from '../../dialogs/DialogExpediente';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ConsultarIncidentes, DescargarIncidentes } from '../../connections/tribunal/IncidenteConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { ConsultarIncidenteProps } from '../../interfaces/tribunal/IncidenteInterface';
import { defaultExpediente, ExpedienteProps } from '../../interfaces/recepcion/ExpedienteInterface';

export const IncidentesPage = () => {

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingDescargar, setLoadingDescargar] = useState( false );

    const [openDetalleExpediente, setOpenDetalleExpediente] = useState( false );
    const [expedienteSeleccionado, setExpedienteSeleccionado] = useState<ExpedienteProps>( defaultExpediente );

    const [recordCount, setRecordCount] = useState( 0 );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [numeroExpediente, setNumeroExpediente] = useState( '' );
    const [fecha, setFecha] = useState( '' );

    const [rows, setRows] = useState<ConsultarIncidenteProps[]>( [] );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setFiltroAplicado( false );

        setMateria( 0 );
        setAutoridad( 0 );
        setNumeroExpediente( '' );
        setFecha( '' );

        setRows( [] );
        setRecordCount( 0 );

        resetPage();

    }

    const handleBuscar = async () => {

        setLoadingSearch( true );
        setFiltroAplicado( true );

        setRecordCount( 0 );
        resetPage();

    }

    const handleDescargar = async () => {

        setLoadingDescargar( true );

        await DescargarIncidentes({
            idMateria: materia,
            idAutoridad: autoridad,
            numeroExpediente,
            fecha: fecha ? moment( fecha ).format( 'YYYY-MM-DD' ) : '',
        }).then( resp => {

            setTimeout(() => {

                if ( resp ) {

                    DownloadFile( `Incidentes-${ Date.now() }.xlsx`, resp );
                    setLoadingDescargar( false );

                }
                else {

                    setLoadingDescargar( false );

                }

            }, 700);

        });

    }

    const abrirDetalleExpediente = ( expediente: ExpedienteProps ) => {

        setExpedienteSeleccionado( expediente );
        setOpenDetalleExpediente( true );

    };

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            if ( materia !== 0 ) {

                await ObtenerAutoridadesMaterias( materia ).then( resp => {
                    setAutoridadArray( resp );
                });

            }
        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultarIncidentes({
                page,
                rowsPerPage,
                idAutoridad: 0,
                idMateria: 0,
                numeroExpediente: '',
                fecha: ''
            }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultarIncidentes({
                page,
                rowsPerPage,
                idAutoridad: autoridad,
                idMateria: materia,
                numeroExpediente,
                fecha: fecha ? moment( fecha ).format( 'YYYY-MM-DD' ) : '',
            }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, materia, autoridad, numeroExpediente, fecha ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Incidentes' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 } >

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>
                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>
                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>
                                        <Select
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                            disabled={ filtroAplicado || materia === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        fullWidth
                                        label='Número de expediente'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        autoComplete='off'
                                        variant='outlined'
                                        value={ numeroExpediente }
                                        onChange={ (e) => setNumeroExpediente( e.target.value ) }
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es">
                                        <DatePicker
                                            label="Fecha"
                                            value={ fecha ? moment( fecha ) : null }
                                            onChange={ (newValue) => setFecha( newValue ? newValue.format( 'YYYY-MM-DD' ) : '' ) }
                                            disabled={ filtroAplicado }
                                            slotProps={{ textField: { fullWidth: true, InputLabelProps: { shrink: true } } }}
                                        />
                                    </LocalizationProvider>
                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>
                                    <Button
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ loadingSearch }
                                        disabled={ (!filtroAplicado && (materia === 0 && autoridad === 0 && numeroExpediente === '' && !fecha)) }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>
                                </Grid>
                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'right' }>

                    <Button
                        color='secondary'
                        variant="outlined"
                        sx={{ mt: 1 }}
                        loading={ loadingDescargar }
                        disabled={ rows.length === 0 }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                  <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minHeight: rows.length === 0 ? 450 : 0 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%', fontWeight: 'bold', textAlign: 'center' }}>Expediente</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>Ver acuerdo</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>Sentencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>Estatus</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( ( { fecha, numeroExpediente, documentoIncidente, documentoSentencia, fechaConclusion, numeroSentencia, estatus, idEstatus, expediente }, index ) => (

                                        <TableRow key={ index } sx={{ '& td': { py: 2 } }}>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='subtitle1'>
                                                    { fecha ? moment( fecha ).format( 'DD-MM-YYYY' ) : '' }
                                                </Typography>

                                                <Typography variant='caption' color='text.secondary'>
                                                    { fecha ? moment( fecha ).format( 'hh:mm a' ) : '' }
                                                </Typography>

                                            </TableCell>

                                            <TableCell>
                                                {
                                                    numeroExpediente
                                                    &&
                                                        <Button
                                                            fullWidth
                                                            variant='contained'
                                                            onClick={ () => abrirDetalleExpediente( expediente ) }
                                                        >
                                                            { numeroExpediente }
                                                        </Button>
                                                }
                                            </TableCell>

                                            <TableCell>

                                                {
                                                    documentoIncidente
                                                    &&
                                                        <Button
                                                            fullWidth
                                                            variant='contained'
                                                            onClick={ () => {
                                                                setDocumento( documentoIncidente );
                                                                setOpenDocumento( true );
                                                            }}
                                                        >
                                                            Ver
                                                        </Button>
                                                }

                                            </TableCell>

                                            <TableCell>

                                                {
                                                    documentoSentencia
                                                    ?
                                                        <Button
                                                            fullWidth
                                                            variant='contained'
                                                            onClick={ () => {
                                                                setDocumento( documentoSentencia );
                                                                setOpenDocumento( true );
                                                            }}
                                                        >
                                                            { numeroSentencia }
                                                        </Button>
                                                    :
                                                        <Typography variant='subtitle1'>
                                                            { numeroSentencia }
                                                        </Typography>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }} >

                                                {
                                                    fechaConclusion
                                                    &&
                                                        <>
                                                            <Typography variant='subtitle1'>
                                                                { moment( fechaConclusion ).format( 'DD-MM-YYYY' ) }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mb: 1 }}>
                                                                { moment( fechaConclusion ).format( 'hh:mm a' ) }
                                                            </Typography>
                                                        </>
                                                }

                                                <Chip
                                                    variant='filled'
                                                    sx={{ fontWeight: 'bold' }}
                                                    color={ idEstatus === 6 ? 'primary' : 'default' }
                                                    label={
                                                        <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 13 }>
                                                            { estatus }
                                                        </Typography>
                                                    }
                                                />

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    ( rows.length === 0 && !loading ) ? (
                                        <TableRow style={{ height: 100 }}>
                                            <TableCell colSpan={ 5 } align="center">
                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : loading && (
                                        <TableRow style={{ height: 100 }}>
                                            <TableCell colSpan={ 5 } align="center">
                                                <CircularProgress size={ 26 } />
                                            </TableCell>
                                        </TableRow>
                                    )
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 3 }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={ ({ from, to, count }) => `${from}-${to} de ${count}` }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <Dialog open={ openDocumento } onClose={ () => {} } fullWidth={ true } maxWidth="md">
                <DialogContent>
                    <Grid container spacing={ 3 }>
                        <Grid size={{ md: 12, xs: 12 }} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                            {
                                documento ? (
                                    <iframe title='acuerdo' src={ documento } height="500px" width="100%"></iframe>
                                ) : (
                                    <Typography variant='subtitle2' sx={{ fontSize: 18, fontWeight: 'bold', mt: 10, mb: 10 }}>
                                        No se encontró el acuerdo
                                    </Typography>
                                )
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={ () => { setOpenDocumento( false ); setDocumento( '' ); } }>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>

            <DialogExpediente
                expediente={ expedienteSeleccionado }
                openDialog={ openDetalleExpediente }
                handleCloseDialog={ () => setOpenDetalleExpediente( false ) }
            />
        </Layout>
    );
};